import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { ConsentService } from 'src/app/services/consentService/consent.service';

@Component({
  selector: 'app-consent-dialog',
  templateUrl: './consent-dialog.component.html',
  styleUrls: ['./consent-dialog.component.less']
})
export class ConsentDialogComponent {
  consents = this.consentService.getAllConcents();
  constructor(public dialogRef: MatDialogRef<ConsentDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: any, private consentService: ConsentService) {
  }

  // Accept user selection consents
  confirm() {
    this.consentService.acceptSelections(this.consents);
    this.dialogRef.close();
  }

  // Accept all consents
  confirmAll() {
    this.consentService.acceptAll();
    this.dialogRef.close();
  }
}